// extracted by mini-css-extract-plugin
module.exports = {"main-component":"verticalBar_main-component__2uTDu"};